import { Logo } from '../components/Logo';
import { site } from '../data/site';
import styles from './Footer.module.css';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <Logo size="sm" />
        <div>
          © {year} {site.legalName} · all rights reserved
        </div>
        <div aria-hidden="true">exit 0</div>
      </div>
    </footer>
  );
}
